import React from "react";
import { motion } from "framer-motion";
import { FaChalkboardTeacher, FaMobileAlt, FaChartLine, FaUsers, FaDollarSign } from "react-icons/fa";
import "./WhyChoose.css";

const features = [
  {
    icon: <FaChalkboardTeacher />,
    title: "Expert Instruction",
    desc: "Learn from industry leaders with real-world experience—no fluff, just actionable insights.",
  },
  {
    icon: <FaMobileAlt />,
    title: "Flexible & Accessible",
    desc: "Study anytime, anywhere with mobile-friendly courses and bite-sized modules that fit your life.",
  },
  {
    icon: <FaChartLine />,
    title: "Proven Results",
    desc: "95% of our learners report career boosts within 6 months—join the success stories.",
  },
  {
    icon: <FaUsers />,
    title: "Community & Support",
    desc: "Connect in live forums, get personalized mentoring, and access lifetime resources.",
  },
  {
    icon: <FaDollarSign />,
    title: "Affordable Excellence",
    desc: "Premium content at a fraction of traditional costs, with flexible payment plans.",
  },
   {
    icon: <FaUsers />,
    title: "Trusted by Physicians",
    desc: "Trusted by Physicians: Join a growing community of healthcare practitioners worldwide.",
  },
];

const WhyChoose = () => {
  return (
    <section className="whychoose">
      <motion.h2
        className="whychoose-title"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        Why Choose <span>Medby Academy?</span>
      </motion.h2>

      <motion.p
        className="whychoose-subtitle"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.8 }}
      >
        Discover why thousands trust us to elevate their learning journey.
      </motion.p>

      <div className="whychoose-grid">
        {features.map((feature, index) => (
          <motion.div
            className="whychoose-card"
            key={index}
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2 }}
          >
            <div className="icon">{feature.icon}</div>
            <h3>{feature.title}</h3>
            <p>{feature.desc}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default WhyChoose;
